<template>
  <div class=" ">
    <v-layout>
      <v-flex>
        <section>
          <v-card flat>
            <v-card-text class="pa-0">

              <v-row 
                style="height: 100vh;">
                <v-col 
                  cols="12"
                  md="5"
                  class="pl-9">
                  <v-card class="" flat style="background: #240087; border-radius: 16px;" height="100%">
                    <v-card-text class="pa-10" style="height: 100%;">
                      <div>
                        <div>
                          <div class="mb-12">
                            <!-- <v-img
                              src="@/assets/logo/Logo.png"
                              contain
                              style="width: 273px; height: 40px;">
                            </v-img> -->
                          </div>
                          <div>
                            <div class="fs-32 white--text font-weight-bold mb-6">
                              Sistem Akunting Terintegrasi
                            </div>
                            <div class="fs-15 white--text">
                              Layanan Sistem Informasi Manajemen Terintegrasi dalam mengelola dan mengembangkan Usaha Anda.
                            </div>
                          </div>
                        </div>
                        <div class="mt-16 pt-16">
                          <v-img
                            src="@/assets/image/img_login.png"
                            contain>
                          </v-img>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col 
                  cols="12"
                  md="7"
                  style="height: 100%; display: flex; align-items: center; justify-content: center;">
                  <v-card
                    flat
                    style="width: 500px;">
                    <div>
                      <v-card
                        flat
                        color="#FFFFFFB2"
                        class="border-radius">
                        <v-card-text
                          class="pa-0">
                          <div
                            class="mb-6">
                            <div
                              class="fs-30 black_one font-weight-bold black--text mb-12">
                              Masuk
                            </div>
                          </div>
    
                          <ValidationObserver 
                            ref="observer">
                            <v-form class="text-left mb-0">
                              <div class="fs-14 mb-1 black_two">
                                Email
                              </div>
                              <ValidationProvider 
                                name="Email" 
                                rules="required" 
                                v-slot="{ errors }">
                                <v-text-field
                                  v-on:keyup.enter="save"
                                  class="no_box"
                                  outlined
                                  dense
                                  :color="set_color"
                                  style="border-radius: 4px;"
                                  placeholder="Masukan email yang telah didaftarkan"
    
                                  vv-uppercase
    
                                  v-model="form.email"
                                  :error-messages="errors"
                                  required>
                                </v-text-field>
                              </ValidationProvider>
    
                              <div class="fs-14 mb-1 black_two">
                                Kata Sandi
                              </div>
                              <ValidationProvider 
                                name="password" 
                                rules="required|min:5|max:30" 
                                v-slot="{ errors }">
                                <v-text-field
                                  v-on:keyup.enter="save"
                                  class="no_box"
                                  outlined
                                  dense
                                  :color="set_color"
                                  style="border-radius: 4px;"
                                  placeholder="Masukan kata sandi"
                                  :type="show ? 'text' : 'password'"
                                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                  @click:append="show = !show"
                                  :counter="30"
    
                                  vv-uppercase
                                  
                                  v-model="form.password"
                                  :error-messages="errors"
                                  required>
                                </v-text-field>
                              </ValidationProvider>
                            </v-form>
                          </ValidationObserver>
    
                          <div 
                            class="text-center mb-6">
                            <div v-if="message.error.length > 0"
                              class="text-center my-4">
                              <div
                                class="error--text d-flex align-start">
                                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                                
                                <span
                                  class="ml-1">
                                  {{ message.error }}
                                </span>
                              </div>
                            </div>
    
                            <!-- <div class="blue_one fs-14 text-right mt-1 mb-5" style="font-weight: 600;">
                              <span class="cursor-pointer">Lupa Kata Sandi</span>
                            </div> -->
    
                            <v-btn
                              :disabled="process.form"
                              :loading="process.form"
                              @click="save()"
                              block
                              color="#240087"
                              width="170"
                              height="40"
                              elevation="0"
                              class="title font-weight-bold white--text text-capitalize border-radius">
                              Masuk
                            </v-btn>
    
                            <!-- <div class="text-center fs-14 my-10">
                              <span class="black_two">Belum punya akun? </span>
                              <span class="blue_one cursor-pointer" @click="toRegister()">Daftar</span>
                            </div> -->
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,
        form: {
          email: '',
          password: ''
          // device: 'web'
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      
    },
    methods: {

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          await post('auth/login', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              // console.log(res.results.data)
              let user = res.results.data,
                  menu_arr = res.results.data.cat_menu_array.length < 1 ? [] : res.results.data.cat_menu_array,
                  menu_default = [
          {
            id: 1,
            label: "CoA",
            icon: "mdi-file-cog",
            link: "/coa",
            color: "primary",
            action: {
              add: true,
              update: true,
              delete: true,
              export: true,
              add_sub: true
            }
          },
          {
            id: 52,
            label: "Set Saldo Awal",
            icon: "mdi-currency-usd",
            link: "/set-saldo-awal",
            color: "pink",
            action: []
          },
          {
            id: 4,
            label: "Jurnal",
            icon: "mdi-file-document-edit-outline",
            color: "warning",
            link: "/jurnal",
            action: {
              add: true,
              list_template: true,
              // add_template: true,
              delete_verification: true,
              varification: true,
              update: true
            }
          },
          {
            id: 5,
            label: "Buku Besar",
            icon: "mdi-book-open-blank-variant",
            link: "/buku-besar",
            color: "success",
            action: {
              export: true
            }
          },
          {
            id: 2,
            label: "Neraca",
            icon: "mdi-scale-balance",
            link: "/neraca",
            color: "accent",
            action:{
              export: true
            }
          },
          {
            id: 3,
            label: "Laba Rugi",
            icon: "mdi-chart-bell-curve-cumulative",
            link: "/laba-rugi",
            color: "pink",
            action: {
              export: true
            }
          },
          {
            id: 6,
            label: "Tutup Buku",
            icon: "mdi-book-remove",
            link: "/trial-balance",
            color: "#3E2723",
            action: {
              buka_buku: true,
              tutup_buku: true
            }
          },
          {
            id: 7,
            label: "Project",
            icon: "mdi-folder-account",
            link: "/project",
            color: "#00838F",
            action: {
              add: true,
              update: true,
              delete: true,
              add_rencana: true,
              delete_rencana: true,
              export: true,
              // data_report_rencana: true,
              add_report_rencana: true,
              delete_report_rencana: true
            }
          },
          {
            id: 14,
            label: "Vendor",
            icon: "mdi-home-account",
            link: "/vendor",
            color: "#00838F",
            action: {
              add: true,
              update: true,
              delete: true,
              add_rencana: true,
              export: true,
              delete_rencana: true,
              // data_report_rencana: true,
              add_report_rencana: true,
              delete_report_rencana: true,
              add_project: true,
              delete_project: true
            }
          },
          {
            id: 8,
            label: "Divisi",
            icon: "mdi-bookmark-box",
            link: "/divisi",
            color: "#BF360C",
            action: {
              add: true,
              update: true,
              delete: true,
              add_rencana: true,
              delete_rencana: true,
              export: true,
              // data_report_rencana: true,
              add_report_rencana: true,
              delete_report_rencana: true
            }
          },
          {
            id: 53,
            label: "Laporan Sub Keuangan",
            icon: "mdi-file-document",
            link: "/laporan-sub-keuangan",
            color: "#827717",
            action: {
              export: true,
            }
          },
          {
            id: 9,
            label: "Audit Trail",
            icon: "mdi-list-box",
            link: "/audit",
            color: "#455A64",
            action:{
              export: true,
            }
          },
          {
            id: 10,
            label: "Kelola Jurnal",
            icon: "mdi-archive-edit",
            link: "/manage-jurnal",
            color: "red",
            action:{}
          },
          {
            id: 11,
            label: "Pegawai",
            icon: "mdi-account-group",
            link: "/user",
            color: "primary",
            action: {
              add: true,
              update: true,
              delete: true,
              export: true,
              reset_password: true
            }
          },
          {
            id: 12,
            label: "Kategori Pegawai",
            icon: "mdi-shape",
            link: "/category-user",
            color: "#4A148C",
            action: {
              add: true,
              update: true,
              delete: true
            }
          },
          {
            id: 13,
            label: "Konfigurasi",
            icon: "mdi-cog-outline",
            link: "/config",
            color: "black",
            action:{}
          }
        ]
              
              TokenService.saveToken(
                res.results.token,
                JSON.stringify(user),
                JSON.stringify(menu_arr.length > 0 ? menu_arr : menu_default)
              )

              TokenService.saveReload(false)

              TokenService.saveColor(
                '#080679'
              )

              this.$store.commit("setColor", '#080679')

              window.location = `${process.env.BASE_URL}`
              

            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>